import axios from '../wmsAxios'

// 创庺打印任务
export const createPrintJob = (data) => {
    return axios({
        url: '/printJob/create',
        method: 'post',
        data
    })
}

// 查询打印任务列表（管理页面）
export const queryPrintJob = (params) => {
    return axios({
        url: '/printJob/list',
        method: 'get',
        params
    })
}

// 重新打印（从原任务复制新任务）
export const rePrintJob = (jobId) => {
    return axios({
        url: '/printJob/reprint',
        method: 'post',
        data: { jobId }
    })
}

// PDA 轮询获取待打印任务
export const pollPrintJob = (deviceId) => {
    return axios({
        url: '/printJob/poll',
        method: 'get',
        params: { deviceId }
    })
}

// PDA 确认打印完成
export const confirmPrintJobDone = (jobId, printedCount) => {
    return axios({
        url: '/printJob/done',
        method: 'post',
        data: { jobId, printedCount }
    })
}

// PDA 确认打印失败
export const confirmPrintJobFailed = (jobId, errorMessage) => {
    return axios({
        url: '/printJob/fail',
        method: 'post',
        data: { jobId, errorMessage }
    })
}

// 获取设备列表（登录时选择设备）
export const getPrintDevices = (deviceId) => {
    return axios({
        url: '/printJob/devices/' + deviceId,
        method: 'get'
    })
}

// 获取标签模板 ZPL
export const getLabelFormat = (whId, labelType) => {
    return axios({
        url: '/printJob/labelFormat',
        method: 'get',
        params: { whId, labelType }
    })
}

// 获取仓库下的设备列表
export const getDevicesByWh = (whId) => {
    return axios({
        url: '/printJob/devicesByWh',
        method: 'get',
        params: { whId }
    })
}

// 保存用户选择的设备ID
export const saveDeviceId = (userName, deviceId, whId) => {
    return axios({
        url: '/printJob/saveDevice',
        method: 'post',
        data: { userName, deviceId, whId }
    })
}

// 获取用户已保存的设备ID
export const getSavedDeviceId = (userName, whId) => {
    return axios({
        url: '/printJob/savedDevice',
        method: 'get',
        params: { userName, whId }
    })
}



// WEBPACK FOOTER //
// ./src/http/moudules/printJob.js